import { createApp } from 'vue';
import StatCardBlock from './StatCardBlock.vue';

import './StatCardBlock-entry.scss';

export default function mountStatCardBlock() {
	const blocks = document.querySelectorAll('[data-feature="stat-card-block"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'StatCardBlockApp',
		});

		app.component('stat-card-block', StatCardBlock);
		app.mount(block);
	})

}

mountStatCardBlock()